(function () {
    const popup = document.getElementById('formLeadsPopup');
    if (!popup) return;

    const delay = parseInt(popup.dataset.popupDelay) || 3000;
    const closeBtn = popup.querySelector('.form-leads-popup__close');
    const overlay = popup.querySelector('.form-leads-popup__overlay');
    const dismissBtn = popup.querySelector('.form-leads-popup__dismiss');
    const thankYouModal = document.querySelector('.form-leads-popup__thank-you');
    const thankYouCloseButtons = document.querySelectorAll('.form-leads-popup__close--thank-you');

    function showPopup() {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    function dismissPopup() {
        closePopup();
    }

    function showThankYouModal() {
        // Esconde o popup principal
        popup.classList.remove('active');
        
        // Mostra o modal de agradecimento
        if (thankYouModal) {
            thankYouModal.classList.add('active');
            popup.classList.add('active');
            document.body.style.overflow = 'hidden';

            // Fecha automaticamente o modal de agradecimento após 5 segundos
            setTimeout(function () {
                closeThankYouModal();
            }, 5000);
        }
    }

    function closeThankYouModal() {
        if (thankYouModal) {
            thankYouModal.classList.remove('active');
            document.body.style.overflow = '';
            popup.classList.remove('active');
        }
    }

    // Show popup after delay - only once per session
    const sessionKey = 'formLeadsPopupShown';
    
    if (!sessionStorage.getItem(sessionKey)) {
        console.log('Form Leads Popup: Agendado para aparecer em ' + delay + 'ms');
        setTimeout(function () {
            console.log('Form Leads Popup: Exibindo agora');
            showPopup();
            sessionStorage.setItem(sessionKey, 'true');
        }, delay);
    } else {
        console.log('Form Leads Popup: Já exibido nesta sessão');
    }

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
    }

    // Overlay click
    if (overlay) {
        overlay.addEventListener('click', closePopup);
    }

    // Dismiss button
    if (dismissBtn) {
        dismissBtn.addEventListener('click', dismissPopup);
    }

    // Submit button - captura email e insere no formulário do app
    const submitBtn = popup.querySelector('.form-leads-popup__submit');
    const emailInput = popup.querySelector('#Email');

    if (submitBtn && emailInput) {
        submitBtn.addEventListener('click', function () {
            console.log('=== INÍCIO DO PROCESSO ===');

            // Captura o email do popup
            const email = emailInput.value.trim();
            console.log('1. Email capturado do popup:', email);

            // Valida se o email foi preenchido
            if (!email) {
                console.warn('Email vazio');
                emailInput.reportValidity();
                return;
            }

            // Valida formato do email
            if (!emailInput.checkValidity()) {
                console.warn('Email inválido');
                emailInput.reportValidity();
                return;
            }

            // Função para obter o formulário dentro do shadowRoot do #app-embed
            function getNewsletterForm() {
                console.log('2. Buscando elemento #app-embed...');
                const host = document.getElementById('app-embed');
                console.log('   - Elemento #app-embed encontrado:', !!host);

                if (!host) {
                    console.error('   - #app-embed não existe no DOM');
                    return null;
                }

                console.log('   - shadowRoot existe:', !!host.shadowRoot);
                if (!host.shadowRoot) {
                    console.error('   - shadowRoot não encontrado em #app-embed');
                    return null;
                }

                const form = host.shadowRoot.querySelector('form[data-testid="form"]');
                console.log('   - Formulário com data-testid="form" encontrado:', !!form);

                if (!form) {
                    // Tenta buscar qualquer form
                    const anyForm = host.shadowRoot.querySelector('form');
                    console.log('   - Qualquer formulário encontrado:', !!anyForm);
                    return anyForm;
                }

                return form;
            }

            // Função para disparar evento input
            function dispatchInput(el) {
                el.dispatchEvent(new Event('input', { bubbles: true }));
                el.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Obtém o formulário do app
            const appForm = getNewsletterForm();

            if (!appForm) {
                console.error('3. ERRO: Formulário do app não encontrado');
                console.log('   Verifique se o app está carregado e se possui shadowRoot');
                alert('Erro ao processar o formulário. Por favor, tente novamente.');
                return;
            }

            console.log('3. Formulário do app encontrado:', appForm);

            // Preenche o campo de email no formulário do app
            console.log('4. Buscando campo de email no formulário do app...');
            const appEmailInput = appForm.querySelector('#email')
                || appForm.querySelector('input[type="email"]')
                || appForm.querySelector('input[inputmode="email"]');

            console.log('   - Campo de email encontrado:', !!appEmailInput);

            if (appEmailInput) {
                console.log('   - Tipo do campo:', appEmailInput.type);
                console.log('   - ID do campo:', appEmailInput.id);

                appEmailInput.value = email;
                dispatchInput(appEmailInput);
                console.log('5. Email inserido no formulário do app:', appEmailInput.value);

                // Aguarda um momento e clica no botão submit do app
                setTimeout(function () {
                    console.log('6. Buscando botão submit...');
                    const appSubmitBtn = appForm.querySelector('button[data-testid="btn-form-submit"]')
                        || appForm.querySelector('button[type="submit"]')
                        || appForm.querySelector('button');

                    console.log('   - Botão submit encontrado:', !!appSubmitBtn);

                    if (appSubmitBtn) {
                        console.log('   - Texto do botão:', appSubmitBtn.textContent);
                        appSubmitBtn.click();
                        console.log('7. ✓ Formulário do app enviado com sucesso');

                        // Mostra o modal de agradecimento após envio
                        setTimeout(function () {
                            showThankYouModal();
                            console.log('8. ✓ Modal de agradecimento exibido');
                            console.log('=== PROCESSO CONCLUÍDO COM SUCESSO ===');
                        }, 500);
                    } else {
                        console.error('6. ERRO: Botão submit do app não encontrado');
                        alert('Erro ao enviar o formulário. Por favor, tente novamente.');
                    }
                }, 300);
            } else {
                console.error('4. ERRO: Campo de email do app não encontrado');
                console.log('   Campos disponíveis no formulário:');
                const allInputs = appForm.querySelectorAll('input');
                allInputs.forEach((input, i) => {
                    console.log(`   - Input ${i}: type="${input.type}", id="${input.id}", name="${input.name}"`);
                });
                alert('Erro ao processar o formulário. Por favor, tente novamente.');
            }
        });
    }

    // Thank You Modal close buttons
    if (thankYouCloseButtons.length > 0) {
        thankYouCloseButtons.forEach(function(btn) {
            btn.addEventListener('click', closeThankYouModal);
        });
    }

    // ESC key to close
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            if (thankYouModal && thankYouModal.classList.contains('active')) {
                closeThankYouModal();
            } else if (popup.classList.contains('active')) {
                closePopup();
            }
        }
    });
})();